module.exports = __webpack_public_path__ + "img/i_instant.aa5a9dc3.svg";